import { format, parse } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

export const formatDateInTimezone = (date: string | Date, timezone: string, formatStr: string = 'PPpp') => {
  const parsedDate = typeof date === 'string' ? 
    new Date(date) : // Use native Date parsing for ISO strings
    date;
  const zonedDate = toZonedTime(parsedDate, timezone);
  return format(zonedDate, formatStr);
};

export const formatRelativeTime = (date: string | Date) => {
  const parsedDate = typeof date === 'string' ? 
    new Date(date) :
    date;
  const now = new Date();
  const diffInMinutes = Math.floor((now.getTime() - parsedDate.getTime()) / (1000 * 60));
  
  if (diffInMinutes < 60) {
    return `${diffInMinutes} minutes ago`;
  }
  
  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return `${diffInHours} hours ago`;
  }
  
  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays === 1) {
    return 'yesterday';
  }
  
  return format(parsedDate, 'MMM d, yyyy');
};

export const isToday = (date: string | Date, timezone: string) => {
  const parsedDate = typeof date === 'string' ? 
    new Date(date) :
    date;
  const zonedDate = toZonedTime(parsedDate, timezone);
  const today = toZonedTime(new Date(), timezone);
  
  return (
    zonedDate.getFullYear() === today.getFullYear() &&
    zonedDate.getMonth() === today.getMonth() &&
    zonedDate.getDate() === today.getDate()
  );
};

export const startOfDay = (timezone: string) => {
  const now = new Date();
  const zonedDate = toZonedTime(now, timezone);
  zonedDate.setHours(0, 0, 0, 0);
  return zonedDate;
};

export const endOfDay = (timezone: string) => {
  const now = new Date();
  const zonedDate = toZonedTime(now, timezone);
  zonedDate.setHours(23, 59, 59, 999);
  return zonedDate;
};
